import Header from './Header';
import Footer from './Footer';
import FloatingAbkasanAI from './FloatingAbkasanAI';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <FloatingAbkasanAI />
    </div>
  );
};

export default Layout;
